export const MISSION_STEP = {
    MOTIF: "motif",
    PERIOD: "period",
    DETAILS: "details",
    INVITATION: "invitation",
    CONFIRMATION: "confirmation",
};

// Order of the "use a template" flow, the only place it is written. `page` is the
// FormsCreate page the context's `page` points to, so the order does not follow it.
export const MISSION_STEPS = [
    { key: MISSION_STEP.MOTIF, page: 3, defaultLabel: "Motif" },
    { key: MISSION_STEP.PERIOD, page: 5, defaultLabel: "Période" },
    { key: MISSION_STEP.DETAILS, page: 9, defaultLabel: "Détails" },
    { key: MISSION_STEP.INVITATION, page: 7, defaultLabel: "Invitation" },
    {
        key: MISSION_STEP.CONFIRMATION,
        page: 10,
        defaultLabel: "Confirmation",
    },
];

export const MISSION_END_PAGE = 11;

export const MISSION_STEPS_COUNT = MISSION_STEPS.length;

export const MISSION_STEP_PAGES = MISSION_STEPS.map((step) => step.page);

export const MISSION_VALID_PAGES = [...MISSION_STEP_PAGES, MISSION_END_PAGE];

export const MISSION_FIRST_PAGE = MISSION_STEP_PAGES[0];

export const getMissionStepPage = (stepKey) =>
    MISSION_STEPS.find((step) => step.key === stepKey)?.page;

/** 0-based position of a page in the flow, -1 outside of it (end page included). */
export const getMissionStepIndex = (page) => MISSION_STEP_PAGES.indexOf(page);

export const isMissionConfirmationPage = (page) =>
    page === getMissionStepPage(MISSION_STEP.CONFIRMATION);

export const getMissionStepLabel = (language, step) =>
    language.getValue(`missionCreation.steps.${step.key}`, step.defaultLabel);
